import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, ReplaySubject, tap } from 'rxjs';
import { environment } from 'environments/environment';
@Injectable({
    providedIn: 'root',
})
export class RolesService {
    private api: string = environment.api;
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {}
    getAllRoles(): Observable<any> {
        return this._httpClient.get(`${this.api}/roles`);
    }
    getUserRolesByUsername(id: string): Observable<any> {
        return this._httpClient.get(`${this.api}/user/role?user=${id}`);
    }
    createRole(role: any): Observable<any> {
        return this._httpClient.post(`${this.api}/roles/create`, role);
    }
    createUserRole(role: any): Observable<any> {
        return this._httpClient.post(`${this.api}/user/role/create`, role);
    }
    updateRole(role: any): Observable<any> {
        return this._httpClient.post(`${this.api}/roles/update`, role);
    }
    deleteRole(role: any): Observable<any> {
        return this._httpClient.post(`${this.api}/roles/delete`, role);
    }
    deleteUserRole(role: any): Observable<any> {
        return this._httpClient.post(`${this.api}/user/role/delete`, role);
    }
    getActiveUserRoles(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._httpClient
                .get(`${this.api}/auth/roles`)
                .pipe(
                    catchError((error: any): any => {
                        resolve(error);
                        throw new Error(error.message);
                    })
                )
                .subscribe((response) => {
                    resolve(response);
                });
        });
    }
    serializeDataForUserRole(data: any) {
        return {
            user: data.username,
            roleName: data.roles.name,
            merchantSlug: data.merchantSlug.slug,
            description: data.roles.description,
        };
    }
}
